'use client';

import { useState } from 'react';

import { DeliverableTypeSelectField } from '@/features/deliverable-types/components';
import { Popover } from '@web/ui';

import styles from './JobTasksComponents.module.scss';

type DeliverableTypeOption = {
  id: string;
  label: string;
};

type DeliverableTypeControlProps = {
  value: DeliverableTypeOption | null;
  readOnly: boolean;
  isBusy?: boolean;
  onChange?: (nextType: DeliverableTypeOption | null) => void;
};

export function DeliverableTypeControl({
  value,
  readOnly,
  isBusy = false,
  onChange,
}: DeliverableTypeControlProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const deliverableTypeLabel = value?.label ?? 'No type';
  const disabled = readOnly || isBusy || !onChange;

  return (
    <span className={styles.metricCard}>
      <button
        type="button"
        aria-label={`Update deliverable type: ${deliverableTypeLabel}`}
        className={styles.inlineMetaButton}
        disabled={disabled}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        {deliverableTypeLabel}
      </button>
      {onChange ? (
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
        >
          <div className={styles.inlineMetaSelect}>
            <DeliverableTypeSelectField
              value={value}
              label="Deliverable Type"
              onChange={(nextType) => {
                onChange(nextType);
                setAnchorEl(null);
              }}
              disabled={disabled}
            />
          </div>
        </Popover>
      ) : null}
    </span>
  );
}
